import React, { useState, useEffect } from 'react';

import { Link, useNavigate } from 'react-router-dom';




const Homepage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  // Slideshow data - replace with your actual images and descriptions
  const slides = [
    {
      image: "/hero/hero 1.png",
      title: "Innovative Software Solutions",
      description: "Transforming businesses with cutting-edge technology and custom software development tailored to your needs."
    },
    {
      image: "/hero/hero 2.png", 
      title: "Telecommunications Excellence",
      description: "Leading provider of SMS, USSD, and payment solutions across Africa (Kenya, Uganda, Tanzania and Ghana) and beyond (Australia, United Kingdom, USA, India and France)."
    },
    {
      image: "/hero/hero 3.png",
      title: "Developer Resources & APIs",
      description: "Comprehensive tools and APIs to accelerate your development process and streamline integration."
    },
    {
      image: "/hero/hero 4.png",
      title: "Trusted by Industry Leaders",
      description: "Over 10 years of experience serving major telecommunications companies and businesses across Africa and beyond."
    }
  ];

  // Auto-advance slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const services = [
  {
    id: "service1",
    icon: "/assets/BS icon.png",
    title: "SMS Africa - BULK SMS",
    description: "Mass messaging solutions for your business"
  },
  {
    icon: "/assets/USSD icon.png",
    id: "service2",
    title: "USSD",
    description: "Professional call center services"
  },
  {
    icon: "/assets/PREMIUM SMS icon.png",
    id: "service3",
    title: "PREMIUM SMS",
    description: "Real-time customer support solutions"
  },
  {
    icon: "/assets/CHATBOTS icon.png",
    id: "service4",
    title: "CHATBOTS",
    description: "AI-powered customer service automation"
  },
  {
    id: "service5",
    icon: "/assets/Stock Mgt icon.png",
    title: "UZA - STOCK MANAGEMENT SYSTEM",
    description: "Streamline your inventory operations"
  },
  {
    id: "service6",
    icon: "/assets/BS icon.png",
    title: "INFINITY EMAILPRO",
    description: "Streamline your inventory operations"
  },
    {
    id: "service7",
    icon: "/assets/SD icon.png",
    title: "SOFTWARE DEVELOPMENT",
    description: "Custom software solutions tailored to your needs"
  },
   {
    id: "service8",
    icon: "/assets/CHATBOTS icon.png",
    title: "DIGITAL SERVICES",
    description: "Seamless mobile game monetization through carrier billing"
  },
  {
    id: "service9",
    icon: "/assets/SM icon.png",
    title: "SMS Africa - SCHOOL MANAGEMENT SYSTEM",
    description: "Comprehensive solutions for educational institutions"
  },
  {
    id: "service10",
    icon: "/assets/PS icon.png",
    title: "PAYMENT SYSTEM",
    description: "Secure payment processing systems"
  },
 
    
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      

      {/* Slideshow Hero Section */}
      <section className="relative h-80 sm:h-96 md:h-[500px] overflow-hidden">
        {/* Slides Container */}
        <div className="relative w-full h-full">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={slide.image}
                  alt={slide.title}
                  className="w-full h-full object-cover"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 via-blue-800/60 to-blue-700/40"></div>
              </div>

              {/* Content */}
              <div className="absolute inset-0 flex items-center">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                  <div className="max-w-2xl text-white">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold mb-3 sm:mb-4 leading-tight">
                      {slide.title}
                    </h1>
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 sm:mb-8 leading-relaxed opacity-90">
                      {slide.description}
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4">
                      <Link to="/about">
                        <button className="border-2 border-white text-white hover:bg-white hover:text-blue-900 hover:scale-105 hover:shadow-lg px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-semibold transition-all duration-300 ease-in-out transform active:scale-95 relative z-10">
                          Learn More
                        </button>
                      </Link>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        

        {/* Slide Indicators */}
        <div className="absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all ${
                index === currentSlide 
                  ? 'bg-white' 
                  : 'bg-white/50 hover:bg-white/70'
              }`}
            />
          ))}
        </div>

        {/* Progress Bar */}
        <div className="absolute bottom-0 left-0 w-full h-1 bg-white/20">
          <div 
            className="h-full bg-white transition-all duration-5000 ease-linear"
            style={{ 
              width: `${((currentSlide + 1) / slides.length) * 100}%` 
            }}
          />
        </div>
      </section>

      {/* Developer Resources Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center">
            {/* Left side - Images */}
            <div className="lg:w-1/2 mb-8 lg:mb-0">
              <div className="flex flex-col space-y-6">
                {/* Main image */}
                <div className="w-80 h-64 rounded-lg overflow-hidden shadow-lg">
                  <img 
                    src="/assets/primary.png" 
                    alt="Developer Resources" 
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Secondary image */}
                <div className="w-32 h-24 rounded-lg overflow-hidden shadow-lg ml-8">
                  <img 
                    src="/assets/secondary.png" 
                    alt="Team Collaboration" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Right side - Content */}
            <div className="lg:w-1/2 lg:pl-12">
              <h2 className="text-3xl font-bold mb-4">
                DEVELOPER <span className="text-blue-600">RESOURCES</span>
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                We've assembled a collection of tools specifically designed to 
                simplify your journey in using our APIs. With these resources, you 
                can accelerate development and run thorough tests on your apps 
                before releasing them to your audience.
              </p>
              <Link to="/developer-resources">
                <button className="bg-blue-600 text-white px-8 py-3 rounded hover:bg-blue-700 transition-colors">
                  READ MORE
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      
      {/* Services Section */}
<section className="py-16 bg-gradient-to-br from-blue-600 to-blue-800" id="services">
  <div className="max-w-7xl mx-auto px-4">
    <h2 className="text-4xl font-bold text-white text-center mb-12">
      OUR <span className="text-blue-200">SERVICES</span>
    </h2>
    
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {services.map((service, index) => {
        // Define border colors based on index (cycling through colors for 9 services)
        const borderColors = [
          'border-blue-400',
          'border-yellow-400',
          'border-green-400',
          'border-purple-400',
          'border-pink-400',
          'border-indigo-400',
          'border-red-400',
          'border-cyan-400',
          'border-orange-400'
        ];
        const hoverBorderColors = [
          'hover:border-blue-300',
          'hover:border-yellow-300',
          'hover:border-green-300',
          'hover:border-purple-300',
          'hover:border-pink-300',
          'hover:border-indigo-300',
          'hover:border-red-300',
          'hover:border-cyan-300',
          'hover:border-orange-300'
        ];
        const bgColors = [
          'bg-blue-900',
          'bg-blue-800',
          'bg-blue-900',
          'bg-blue-800',
          'bg-blue-900',
          'bg-blue-800',
          'bg-blue-900',
          'bg-blue-800',
          'bg-blue-900'
        ];

        // Updated function to handle navigation to specific service on services page
        const handleServiceClick = (serviceId) => {
          // Always navigate to services page with the specific service anchor
          window.location.href = `/services#${serviceId}`;
        };
        
        return (
          <div 
            key={index}
            onClick={() => handleServiceClick(service.id)}
            className={`${bgColors[index % bgColors.length]} ${borderColors[index]} ${hoverBorderColors[index]} border-2 bg-opacity-80 backdrop-blur-sm rounded-lg p-6 text-center transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:bg-opacity-100 hover:z-10 cursor-pointer`}
          >
            <div className="flex justify-center mb-4">
              <img 
                src={service.icon} 
                alt={service.title}
                className="w-12 h-12 object-contain"
              />
            </div>
            <h3 className="text-white font-bold text-sm mb-2 leading-tight">
              {service.title}
            </h3>
          </div>
        );
      })}
    </div>
    
    <div className="text-center mt-12">
      <Link to="/services">
        <button className="border-2 border-white text-white px-8 py-3 rounded-full hover:bg-white hover:text-blue-600 transition-all duration-300 transform hover:scale-110 hover:shadow-lg font-semibold">
          EXPLORE MORE
        </button>
      </Link>
    </div>
  </div>
</section>

      
      {/* About Us Section */}
      <section className="py-16 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Left side - Image */}
            <div className="lg:w-1/2">
              <div className="relative">
                <div className="w-full h-80 rounded-lg overflow-hidden shadow-2xl">
                  <img
                    src="/assets/about us icon.png"
                    alt="Infinity Tech innovation showcase"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>


            {/* Right side - Content */}
            <div className="lg:w-1/2">
              <h2 className="text-4xl font-bold mb-6">
                ABOUT <span className="text-blue-600">US</span>
              </h2>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Infinity Tech Africa is a licensed software development company in Kenya offering Bulk SMS, USSD, M-Pesa API integration, POS systems & custom telecom solutions.
              </p>
              <p className="text-gray-600 mb-4 leading-relaxed">
                We are a licensed Content Service Provider (CSP) and Application Service Provider (ASP) accredited by the Communications Authority of Kenya, offering trusted and compliant digital services to businesses, enterprises, SMEs, SACCOs, schools, NGOs and government organisations across East Africa.
              </p>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Since 2016, Infinity Tech Africa has delivered end-to-end technology solutions, including Bulk SMS platforms, USSD applications, M-Pesa API integrations, stock and inventory management (POS) systems, school management systems, and customer survey & online voting solutions.
              </p>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Our team brings over 10 years of expertise in the telecommunications industry, having built multiple applications from the ground up. We understand unique user requirements and design custom software solutions that are reliable, scalable, and tailored to client needs.
              </p>
              <p className="text-gray-600 mb-8 leading-relaxed">
                At Infinity Tech Africa, we are committed to innovation, customer experience, and digital transformation in Kenya and East Africa, helping businesses unlock efficiency and achieve growth through technology.
              </p>

              {/* Our Reach */}
              <div className="mb-8">
                <h3 className="text-2xl font-bold mb-6">
                  OUR <span className="text-blue-600">REACH</span>
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {/* Kenya */}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">KENYA</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• Safaricom</li>
                      <li>• Telkom</li>
                      <li>• Airtel</li>
                    </ul>
                  </div>
                  
                  {/* Tanzania */}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">TANZANIA</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• Airtel</li>
                      <li>• Tigo</li>
                      <li>• Vodacom</li>
                    </ul>
                  </div>
                  
                  {/* Uganda */}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">UGANDA</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• Airtel</li>
                      <li>• MTN</li>
                    </ul>
                  </div>
                  {/* Ghana */}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">GHANA</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• Telecel</li>
                      <li>• MTN</li>
                    </ul>
                  </div>
                  {/* Australia */}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">AUSTRALIA</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• China Mobile</li>
                      
                    </ul>
                  </div>
                  {/* United Kingdom */}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">UNITED KINGDOM</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• China Mobile</li>
                      
                    </ul>
                  </div>
                  {/* USA */}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">USA</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• China Mobile</li>
                      
                    </ul>
                  </div>
                  {/* India*/}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">INDIA</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• China Mobile</li>
                      
                    </ul>
                  </div>
                  {/* France */}
                  <div>
                    <h4 className="font-bold text-blue-600 text-lg mb-2">FRANCE</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• China Mobile</li>
                      
                    </ul>
                  </div>
                </div>
              </div>

              <Link to="/contact">
                <button className="bg-blue-600 text-white px-8 py-3 rounded hover:bg-blue-700 transition-colors">
                  Contact Us
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Our Blog Section */}
<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-4">
    <h2 className="text-4xl font-bold text-center mb-12">
      OUR <span className="text-blue-600">BLOG</span>
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {/* Blog Post 1 */}
      <div
        className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow duration-300"
        onClick={() => navigate('/blogs/5-ways-bulk-sms-boosts-small-business-sales')}
      >
        <div className="h-48 w-full overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2340&q=80"
            alt="Bulk SMS for small business"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-6">
          <div className="flex items-center text-sm text-gray-500 mb-2">
            <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs font-medium mr-2">REGIONAL</span>
            <span>01 FEB 2025</span>
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">
            5 Ways Bulk SMS Boosts Small Business Sales ; discover how mass messaging drives engagement, sales, and customer loyalty.
          </p>
        </div>
      </div>

      {/* Blog Post 2 */}
      <div
        className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow duration-300"
        onClick={() => navigate('/blogs/sms-marketing-checklist-for-kenyan-businesses')}
      >
        <div className="h-48 w-full overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2340&q=80"
            alt="SMS marketing checklist"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-6">
          <div className="flex items-center text-sm text-gray-500 mb-2">
            <span className="bg-green-100 text-green-600 px-2 py-1 rounded text-xs font-medium mr-2">GLOBAL</span>
            <span>06 FEB 2026</span>
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">
            SMS Marketing Checklist for Kenyan Businesses ; your complete guide to launching and managing successful SMS campaigns.
          </p>
        </div>
      </div>

      {/* Blog Post 3 */}
      <div
        className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow duration-300"
        onClick={() => navigate('/blogs/how-to-set-up-a-ussd-code-for-your-business')}
      >
        <div className="h-48 w-full overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2339&q=80"
            alt="USSD code setup"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-6">
          <div className="flex items-center text-sm text-gray-500 mb-2">
            <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs font-medium mr-2">GLOBAL</span>
            <span>08 FEB 2026</span>
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">
            How to Set Up a USSD Code for Your Business ; a step-by-step breakdown of the entire setup process with Infinity Tech Africa.
          </p>
        </div>
      </div>
    </div>

    <div className="text-center mt-8">
      <Link to="/blogs">
        <button className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded hover:bg-blue-600 hover:text-white transition-all duration-300">
          VIEW ALL
        </button>
      </Link>
    </div>
  </div>
</section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">
            TESTIMONIALS
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Testimonial 1 */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center relative">
              <img
                src="/testimonials/test1.png"
                alt="Daniel M."
                className="w-24 h-24 mx-auto rounded-full mb-4 object-cover"
              />
              <h4 className="font-bold text-gray-800">Wycliffe Tardo</h4>
              <p className="text-sm text-gray-600 mb-4">Head of Value Added Services, Telkom Kenya Limited</p>
              <p className="text-gray-700 text-sm leading-relaxed italic mb-8">
                "Infinity Tech International has been a trusted Content Service Provider (CSP) for Telkom Kenya Limited for over five years. Their premium and bulk SMS solutions for corporate clients and aggregators have consistently met our standards, offering reliable service and exceptional support. We highly recommend Infinity Tech for their compliance, professionalism, and commitment to excellence."
              </p>
              <p className="text-xs text-gray-900 font-light italic absolute bottom-4 right-6">3rd November 2017</p>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center relative">
              <img
                src="/testimonials/mel logo.png"
                alt="Linda A."
                className="w-24 h-24 mx-auto rounded-full mb-4 object-contain"
              />
              <h4 className="font-bold text-gray-800">Grace Kimani</h4>
              <p className="text-sm text-gray-600 mb-4">Director, Meliora Technologies Limited</p>
              <p className="text-gray-700 text-sm leading-relaxed italic mb-8">
                "Infinity Tech International has been our trusted SMS and USSD services provider for the past three years. Their solutions have been reliable, and our partnership has been mutually beneficial. We highly recommend Infinity Tech for their professionalism, seamless service delivery, and commitment to fostering long-term business relationships."
              </p>
              <p className="text-xs text-gray-900 font-light italic absolute bottom-4 right-6">21st January 2023</p>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center relative">
              <img
                src="/testimonials/test3.png"
                alt="Linda A."
                className="w-24 h-24 mx-auto rounded-full mb-4 object-cover"
              />
              <h4 className="font-bold text-gray-800">Joel Kaba</h4>
              <p className="text-sm text-gray-600 mb-4">Head of Digital Products & Services, Safaricom PLC</p>
              <p className="text-gray-700 text-sm leading-relaxed italic mb-8">
                "Infinity Tech International has been a trusted Premium Rate Service Provider and Content Service Partner for Safaricom since 2016. Their SMS Gateway, Short Code, USSD, and Mobile Value-Added Services have consistently delivered exceptional quality and reliability for our subscribers. We value their expertise and highly recommend Infinity Tech as a dependable technology partner."
              </p>
              <p className="text-xs text-gray-900 font-light italic absolute bottom-4 right-6">22nd February 2023</p>
            </div>

            {/* Testimonial 4 */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center relative">
              <img
                src="/testimonials/test4.png"
                alt="Linda A."
                className="w-24 h-24 mx-auto rounded-full mb-4 object-cover"
              />
              <h4 className="font-bold text-gray-800">Roseline Nyangugu</h4>
              <p className="text-sm text-gray-600 mb-4">VAS Lead, Airtel Kenya</p>
              <p className="text-gray-700 text-sm leading-relaxed italic mb-8">
                "Infinity Tech International has been a valued Content Service Provider for Airtel Kenya, delivering premium and bulk SMS solutions for our corporate clients and aggregators. Their services have consistently met our compliance standards while demonstrating reliability and excellent support. We commend Infinity Tech as a trusted partner in mobile value-added services."
              </p>
              <p className="text-xs text-gray-900 font-light italic absolute bottom-4 right-6">26th July 2018</p>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center relative">
              <img
                src="/testimonials/test5.png"
                alt="Linda A."
                className="w-24 h-24 mx-auto rounded-full mb-4 object-cover"
              />
              <h4 className="font-bold text-gray-800">Isabella Nyandieka</h4>
              <p className="text-sm text-gray-600 mb-4">Crop Science Division, Bayer East Africa</p>
              <p className="text-gray-700 text-sm leading-relaxed italic mb-8">
                "For the past three years, Infinity Tech International has been our trusted partner for bulk SMS services. Their reliable SMS gateway has consistently handled our messaging traffic with exceptional performance, while their responsive support team has always been available when needed. We highly recommend Infinity Tech for their dependable and professional SMS solutions."
              </p>
              <p className="text-xs text-gray-900 font-light italic absolute bottom-4 right-6">26th March 2024</p>
            </div>

            {/* Testimonial 6 */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center relative">
              <img
                src="/testimonials/acorn logo2.png"
                alt="James K."
                className="w-24 h-24 mx-auto rounded-full mb-4 object-contain"
              />
              <h4 className="font-bold text-gray-800">Washington Gichuru</h4>
              <p className="text-sm text-gray-600 mb-4">IT Systems Manager, Acorn Management Services</p>
              <p className="text-gray-700 text-sm leading-relaxed italic mb-8">
                "We have partnered with Infinity Tech Africa for bulk communication solutions including USSD, shortcode, and alphanumeric messaging services. Their team has demonstrated exceptional dedication, reliable support, and competitive pricing throughout our collaboration. We highly recommend Infinity Tech Africa for their professional and cost-effective communication solutions."
              </p>
              <p className="text-xs text-gray-900 font-light italic absolute bottom-4 right-6">9th July 2023</p>
            </div>
          </div>
        </div>
      </section>

     <footer className="bg-blue-600 text-white py-12">
          <div className="max-w-7xl mx-auto px-6">
            
            {/* Top 3 Columns */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 border-b border-blue-500 pb-10">
              
              {/* About Us */}
              <div className="space-y-3 md:border-r border-white md:pr-6">
                <h3 className="text-lg font-bold mb-2">About Us</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="about" className="hover:text-blue-200">Who we are</a></li>
                  <li><a href="about" className="hover:text-blue-200">News Hub</a></li>
                  <li><a href="about" className="hover:text-blue-200">Our Reach</a></li>
                  
                </ul>
              </div>

              {/* Customer Service */}
              <div className="space-y-3 md:border-r border-white md:px-6">
                <h3 className="text-lg font-bold mb-2">Customer Service</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="contact" className="hover:text-blue-200">Message Us</a></li>
                  
                  <li><a href="contact" className="hover:text-blue-200">Comment/Complaint</a></li>
                </ul>
              </div>

              {/* Join + Payment */}
              <div className="space-y-4 md:pl-6">
                
                <div>
                <h4 className="text-sm font-semibold mb-2">Payment Options</h4>
                <div className="flex space-x-4">
                  <img src="/icons/mpesa2.png" alt="Visa" className="h-12 object-contain" />
                  <img src="/icons/mastercard.png" alt="Mastercard" className="h-6 object-contain" />
                  <img src="/icons/visa.png" alt="Amex" className="h-6 object-contain" />
                </div>
              </div>
              </div>
            </div>

            {/* Contact Icons Section */}
            <div className="flex justify-center mt-8 mb-6">
              <div className="flex items-center space-x-6 bg-green-700 px-8 py-4 rounded-lg shadow-lg">
                <span className="text-sm font-semibold">Get in Touch:</span>
                <a 
                  href="tel:+254722943271" 
                  className="bg-white hover:bg-blue-100 p-3 rounded-full transition-all duration-300 transform hover:scale-110 shadow-md"
                  title="Call us"
                >
                  <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </a>
                <a 
                  href="https://wa.me/254722943271" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-white hover:bg-green-50 p-3 rounded-full transition-all duration-300 transform hover:scale-110 shadow-md"
                  title="WhatsApp us"
                >
                  <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Social Media Section */}
            <div className="flex justify-center">
              <div className="flex space-x-4 border border-white p-3 rounded">
                <a href="https://www.facebook.com/SMSAfrica01?mibextid=wwXIfr&rdid=M64RTVM7l0SsUXbw&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1D45K1gBPv%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer"><img src="/icons/facebook.png" alt="Facebook" className="w-6 h-6" /></a>
                <a href="https://www.linkedin.com/company/infinity-tech-africa/" target="_blank" rel="noopener noreferrer"><img src="/icons/linkedin.png" alt="LinkedIn" className="w-6 h-6" /></a>
                <a href="https://www.instagram.com/smsafrica/profilecard/?igsh=eXgwOHBydWdlZGVi" target="_blank" rel="noopener noreferrer"><img src="/icons/email.png" alt="Email" className="w-6 h-6" /></a>
                <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><img src="/icons/x logo.png" alt="Twitter" className="w-6 h-6" /></a>
                <a href="https://www.tiktok.com/@infinitytechafrica?_t=ZM-8xr2bhp0ey0&_r=1" target="_blank" rel="noopener noreferrer"><img src="/icons/tiktok logo2.png" alt="YouTube" className="w-6 h-6" /></a>
              </div>
            </div>

            {/* Bottom Footer */}
            <div className="text-center pt-6 mt-6 border-t border-blue-500 text-sm">
              <p>
  &copy; 2025 Infinity Tech Africa |{' '}
  <a
    href="/privacy-policy.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-blue-200 underline"
  >
    Privacy Policy
  </a>{' '}
  | Terms & Conditions Apply
</p>
            </div>
          </div>
        </footer>




      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden">
          <div className="bg-white w-64 h-full p-6">
            <button 
              onClick={() => setIsMenuOpen(false)}
              className="mb-6 text-gray-600"
            >
              ✕ Close
            </button>
            <div className="flex flex-col space-y-4">
              <a href="#" className="text-gray-700 hover:text-blue-600">HOME</a>
              <a href="#" className="text-gray-700 hover:text-blue-600">ABOUT US</a>
              <a href="#" className="text-gray-700 hover:text-blue-600">SERVICES</a>
              <a href="#" className="text-gray-700 hover:text-blue-600">BLOG</a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Homepage;